// src/App.tsx
import React from 'react';
import IconDemo from './IconDemo';

const App: React.FC = () => {
  return (
    <div>
      <IconDemo />
    </div>
  );
};

export default App;
